module.exports = {"id":"dp2_6l1q4","text":"Managing Digital Identity","instructions":"Which best describes a digital footprint?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"2.6","questionType":"PickOne","random":true,"options":[{"id":"dp2_6l1q4-a1","text":"Data left from online activities","score":1.8},{"id":"dp2_6l1q4-a2","text":"Hardware installed on devices","score":0},{"id":"dp2_6l1q4-a3","text":"Temporary browser errors","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.6/l1q4.json
// module id = 1092
// module chunks = 41